import * as firebase from 'firebase';
const moment = require('moment');

const TimeUtils = {

  getDayStr: (clockOffset, timestamp) => {
    const today = moment().format('MMM Do, YYYY');
    const dayStr = moment(timestamp - clockOffset).format('MMM Do, YYYY');
    return today === dayStr ? 'Today' : dayStr;
  },

  getTimeStr: (clockOffset, timestamp, mode) => {

    if (mode === 'strict'){
      return moment(timestamp - clockOffset).format('h:mm A');
    } else if (mode === 'dynamic'){
      const date = moment(timestamp - clockOffset);

      const today = moment();

      // Today, return time
      const timeStr = date.format('h:mm A');
      if (date.startOf('day').isSame(today.startOf('day'))) {
        return timeStr;
      }

      // This week, return day of the week
      const dayWeekStr = date.format('ddd');
      const dayMonthStr = date.format('MMM D');
      if (date.startOf('week').isSame(today.startOf('week'))) {
        return dayWeekStr;
      } else {
        return dayMonthStr;
      }
    }
  },

  updateLastActTimestamp: (userId, roomId, teamId) => {
    firebase.database()
      .ref(`users/${userId}/rooms/${teamId}/${roomId}/lastUserActTimestamp`)
      .set(firebase.database.ServerValue.TIMESTAMP);
  }
}

export default TimeUtils;



// WEBPACK FOOTER //
// ./src/infra/TimeUtils.js